import React from "react";
import './notAuthorized.css';
import { Link } from "react-router-dom";

function NotAuthorized() {
    return (
        <div className="notAuthorizedContainer">
            <div className="toCenterAlignNotAuthorized">
                Sorry, you're not Authorized to Access this page at this moment.
                <div className="loginLink">Please <Link to="/">Log In</Link> to Deloitte Multi AI Agent Solution to view this Feature</div>
            </div>
        </div>
    )
}

export default NotAuthorized;